/** A desktop counts as online when the server saw it in the last ten minutes. */
export const ONLINE_WINDOW_MS = 10 * 60_000;

export function isOnline(lastSeenAt: string | null, now: number = Date.now()): boolean {
  if (lastSeenAt === null) return false;
  const seen = new Date(lastSeenAt).getTime();
  return !Number.isNaN(seen) && now - seen <= ONLINE_WINDOW_MS;
}
